export default "__VITE_ASSET__Dqpgzt6l__"